import React from 'react';
import { FloatingMenu, MainButton, ChildButton } from 'react-floating-button-menu';
import Cerrar from '../../media/iconos/Cerrar';
import Reporte from '../../media/iconos/Reporte';
import Cerrado from '../../media/iconos/Cerrado';
import '../../media/css_menu/menu.css';
import { withRouter } from "react-router-dom";
import Abierto from '../../media/iconos/Abierto';

class MenuFlotanteSoporte extends React.Component {

    constructor(props){
        super(props);
        this.state = { isOpen : false, cargando: false };
    }

    render(){
        return <React.Fragment>
            <div className="container-fluid">
                <div className=" container">
                    <div className="menu__container--float">
                        <FloatingMenu slideSpeed={500} direction="up" spacing={10} isOpen={this.state.isOpen} className="float__menu">
                            <MainButton iconResting={<Cerrado />} iconActive={<Abierto />} background="#003ec5" onClick={() => this.setState({ isOpen: !this.state.isOpen })} size={56} />
                            <ChildButton icon={<Cerrar />} background="#003ec5" size={50} onClick={()=>{this.setState({cargando: true}); this.props.servicio.cerrarSesion().then(data=>{ this.setState({cargando: false}); window.location = data}).catch(err =>{ this.setState({cargando: true}); console.log(err);})}}  />
                            <ChildButton icon={<Reporte />} background="#003ec5" size={50} onClick={()=> this.props.history.push("/vw/admin/reporte") }/>
                        </FloatingMenu>
                    </div>
                </div>
            </div>
            <div className={"page__cargando" + (this.state.cargando ? " d-block" : " d-none")}></div>
        </React.Fragment>
    }
}

export default withRouter(MenuFlotanteSoporte);